<template>
  <div id="passagewayList">
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <span class="label">系统优惠券:</span>
            <el-select
              v-model="filtrate.autoRelease"
              placeholder="请选择"
              clearable
              @change="getList(1)"
            >
              <el-option label="是" value="是"> </el-option>
              <el-option label="否" value="否"> </el-option>
            </el-select>
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置
            </el-button>
          </li>
        </ul>
        <ul>
          <li>
            <el-button
              class="addCoupon"
              type="primary"
              @click="$refs.editCouponDialog.show = true"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponTab-add'
                )
              "
              ><i class="iconfont icon-jiahao"></i> 新增优惠券
            </el-button>
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="couponName" label="优惠券名称" align="center">
        </el-table-column>
        <el-table-column prop="autoRelease" label="系统优惠券" align="center">
        </el-table-column>
        <el-table-column prop="couponType" label="优惠券类型" align="center">
        </el-table-column>
        <el-table-column prop="couponValue" label="最高抵用金额" align="center">
        </el-table-column>
        <el-table-column prop="availNum" label="可用数量" align="center">
        </el-table-column>
        <el-table-column prop="maxIssue" label="最多可领" align="center">
        </el-table-column>
        <el-table-column prop="issuedNum" label="已发数量" align="center">
        </el-table-column>
        <el-table-column prop="expireDays" label="过期天数" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="edit(scope.row)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponTab-edit'
                ) && scope.row.autoRelease !== '是'
              "
              >编辑
            </el-button>
            <el-button
              type="text"
              @click="del(scope.row.couponId)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponTab-delete'
                ) && scope.row.autoRelease !== '是'
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, total, prev, pager, next, jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @current-change="getList"
          @size-change="getList(1)"
        >
        </el-pagination>
      </div>
    </div>
    <edit-coupon-dialog ref="editCouponDialog" :getList="getList" />
  </div>
</template>
<script>
export default {
  components: {
    editCouponDialog: () => import("./editCouponDialog.vue"),
  },
  data() {
    return {
      filtrate: {
        keyword: "",
        autoRelease: "",
      },

      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    edit(row) {
      this.$refs.editCouponDialog.couponId = row.couponId;
      this.$refs.editCouponDialog.addForm = {
        couponName: row.couponName,
        couponType: row.couponType,
        couponValue: row.couponValue,
        couponHours: row.couponHours,
        expireDays: row.expireDays,
        availNum: row.availNum,
        maxIssue: row.maxIssue,
        isDefault: row.isDefault,
      };
      this.$refs.editCouponDialog.show = true;
    },
    del(couponId) {
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$http.post("/coupon/delete", {
            merchantId: this.$route.params.id,
            couponId,
          });
          if (res.code === 0) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    reset() {
      this.filtrate = {
        keyword: "",
        autoRelease: "",
      };
      this.getList(1);
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/coupon/list/all", {
          merchantId: this.$route.params.id,
          pageNum: page,
          pageSize: this.table.pageSize,
          keyword: this.filtrate.keyword,
          autoRelease: this.filtrate.autoRelease
            ? this.filtrate.autoRelease
            : null,
        });
        if (res.code === 0) {
          for (let item of res.data.list) {
            item.createTime = this.$moment(item.createTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          }
          this.table.tableData = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#passagewayList {
  .table-container {
    .table-filtrate {
      ul {
        li {
          .addCoupon {
            background-color: #ff9747;
            border-color: #ff9747;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
